import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import * as React from 'react';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';
import { useAppSelector } from '@/redux/hooks';
import { getBaseUrl } from '@/redux/modules/config';

const AddCreditCardPageHeaderMeta = () => {
    const { formatMessage } = useIntl();
    const baseUrl = useAppSelector(getBaseUrl);
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'addCreditCard.title' }));
    const description = formatMessage({ id: 'addCreditCard.description' });
    const canonical = `${baseUrl}/dashboard/cardonfile`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default AddCreditCardPageHeaderMeta;
